<template>
  <div v-if="memberShow" id="PersonalInformation" style="padding: 0 1em">
    <div class="course_title">新申請</div>

    <div class="table-responsive-sm">
      <table class="table" style="width: 100%; text-align: left">
        <tbody>
          <tr>
            <td colspan="5" align="left">
              <span style="color: #f00"
                ><span style="color: #f00">＊</span>為必填項目。</span
              >
            </td>
          </tr>

          <tr align="left">
            <td colspan="5">
              申請本助學金，家庭年所得不能超過70萬，計算標準比照大專校院弱勢學生入學計畫：<br>
1、未婚者：未成年與其父母或法定監護人合計；已成年與其父母或未成年時之法定監護人合計。<br>
2、已婚者：與其配偶合計。<br>
3、離婚或配偶死亡者：為同學本人之所得總額。<br>
4、其他特殊條件：因父母離婚、遺棄或其他特殊因素，與父母或法定監護人合計顯失公平者，<br>
得敘明理由，並检具相關文件資料（如近３個月內之詳細記事戶籍謄本或其他文件），經學校審查認定後，<br>
該父母或法定監護人免予合計。</td>
          </tr>
          <tr align="left">
            <td colspan="5" class="d-flex flex-wrap" style="gap:0 1.5rem">
              <span style="white-space:nowrap">申請日期：{{ getToday() }}</span>
              <span style="white-space:nowrap">申請學年/學期：{{ queryInfo.schyy }}/{{ queryInfo.smt }}</span>
            </td>
          </tr>
          <!-- 欄位標題：sm 以上才顯示 -->
          <tr class="d-none d-sm-table-row" align="left">
            <td colspan="5" class="px-0 py-1">
              <div class="row no-gutters mx-0 rel-row">
                <div class="col-auto px-2">編號</div>
                <div class="col px-1">關係人姓名</div>
                <div class="col-auto px-1">與學生關係</div>
                <div class="col-auto px-1">國籍</div>
                <div class="col px-1">身分證 / 居留證字號</div>
              </div>
            </td>
          </tr>

          <!-- 關係人1：手機折三行（編號+姓名 / 關係+國籍 / 身分證），桌機單行 -->
          <tr>
            <td colspan="5" class="px-0 py-1">
              <div class="row no-gutters align-items-start mx-0 rel-row">
                <div class="col-auto d-flex align-items-center py-1 px-2">
                  <strong>1</strong>
                </div>
                <div class="col mb-1 mb-sm-0 px-1">
                  <small class="d-block d-sm-none text-muted">關係人姓名</small>
                  <input
                    type="text"
                    class="form-control"
                    v-model="queryInfo.relatedName1"
                    placeholder="輸入姓名"
                    maxlength="60"
                  />
                </div>
                <div class="col-6 col-sm-auto mb-1 mb-sm-0 px-1">
                  <small class="d-block d-sm-none text-muted">與學生關係</small>
                  <b-form-select
                    v-model="queryInfo.relatedStudent1"
                    :options="options1"
                  ></b-form-select>
                </div>
                <div class="col-6 col-sm-auto mb-1 mb-sm-0 px-1">
                  <small class="d-block d-sm-none text-muted">國籍</small>
                  <b-form-select
                    v-model="queryInfo.relatedNationality1"
                    :options="nationalityOptions"
                  ></b-form-select>
                </div>
                <div class="col-12 col-sm px-1">
                  <small class="d-block d-sm-none text-muted">身分證/居留證字號</small>
                  <input
                    type="text"
                    class="form-control"
                    v-model="queryInfo.relatedId1"
                    :placeholder="queryInfo.relatedNationality1 === 'TW' ? '輸入身分證字號' : '輸入居留證號碼'"
                    @input="onIdInput(1)"
                    @blur="validateIdOnBlur(1)"
                  />
                  <small v-if="idError1" style="color:#f00">{{ idError1 }}</small>
                </div>
              </div>
            </td>
          </tr>

          <!-- 關係人2 -->
          <tr>
            <td colspan="5" class="px-0 py-1">
              <div class="row no-gutters align-items-start mx-0 rel-row">
                <div class="col-auto d-flex align-items-center py-1 px-2">
                  <strong>2</strong>
                </div>
                <div class="col mb-1 mb-sm-0 px-1">
                  <small class="d-block d-sm-none text-muted">關係人姓名</small>
                  <input
                    type="text"
                    class="form-control"
                    v-model="queryInfo.relatedName2"
                    placeholder="輸入姓名"
                    maxlength="60"
                  />
                </div>
                <div class="col-6 col-sm-auto mb-1 mb-sm-0 px-1">
                  <small class="d-block d-sm-none text-muted">與學生關係</small>
                  <b-form-select
                    v-model="queryInfo.relatedStudent2"
                    :options="options2"
                  ></b-form-select>
                </div>
                <div class="col-6 col-sm-auto mb-1 mb-sm-0 px-1">
                  <small class="d-block d-sm-none text-muted">國籍</small>
                  <b-form-select
                    v-model="queryInfo.relatedNationality2"
                    :options="nationalityOptions"
                  ></b-form-select>
                </div>
                <div class="col-12 col-sm px-1">
                  <small class="d-block d-sm-none text-muted">身分證/居留證字號</small>
                  <input
                    type="text"
                    class="form-control"
                    v-model="queryInfo.relatedId2"
                    :placeholder="queryInfo.relatedNationality2 === 'TW' ? '輸入身分證字號' : '輸入居留證號碼'"
                    @input="onIdInput(2)"
                    @blur="validateIdOnBlur(2)"
                  />
                  <small v-if="idError2" style="color:#f00">{{ idError2 }}</small>
                </div>
              </div>
            </td>
          </tr>

          <!-- 關係人3 -->
          <tr>
            <td colspan="5" class="px-0 py-1">
              <div class="row no-gutters align-items-start mx-0 rel-row">
                <div class="col-auto d-flex align-items-center py-1 px-2">
                  <strong>3</strong>
                </div>
                <div class="col mb-1 mb-sm-0 px-1">
                  <small class="d-block d-sm-none text-muted">關係人姓名</small>
                  <input
                    type="text"
                    class="form-control"
                    v-model="queryInfo.relatedName3"
                    placeholder="輸入姓名"
                    maxlength="60"
                  />
                </div>
                <div class="col-6 col-sm-auto mb-1 mb-sm-0 px-1">
                  <small class="d-block d-sm-none text-muted">與學生關係</small>
                  <b-form-select
                    v-model="queryInfo.relatedStudent3"
                    :options="options3"
                  ></b-form-select>
                </div>
                <div class="col-6 col-sm-auto mb-1 mb-sm-0 px-1">
                  <small class="d-block d-sm-none text-muted">國籍</small>
                  <b-form-select
                    v-model="queryInfo.relatedNationality3"
                    :options="nationalityOptions"
                  ></b-form-select>
                </div>
                <div class="col-12 col-sm px-1">
                  <small class="d-block d-sm-none text-muted">身分證/居留證字號</small>
                  <input
                    type="text"
                    class="form-control"
                    v-model="queryInfo.relatedId3"
                    :placeholder="queryInfo.relatedNationality3 === 'TW' ? '輸入身分證字號' : '輸入居留證號碼'"
                    @input="onIdInput(3)"
                    @blur="validateIdOnBlur(3)"
                  />
                  <small v-if="idError3" style="color:#f00">{{ idError3 }}</small>
                </div>
              </div>
            </td>
          </tr>

          <tr align="left">
            <td><span style="color: #f00">＊</span>戶籍謄本</td>
            <td colspan="4">
              <b-form-file
                class="mb-2"
                ref="file-input"
                :no-drop="true"
                :no-traverse="true"
                v-model="file"
                @input="fileChange(0)"
                placeholder="上傳戶籍謄本"
               accept=".jpg, .jpeg, .png, .gif, .pdf"
              ></b-form-file>
            </td>
          </tr>
          <tr align="left">
            <td>本人同意</td>
            <td colspan="4">
              送出申請的文字：
本人確認有中華民國戶籍，就讀本校「產學攜手合作計畫」專班，具有學籍且修業年限內之學生。<br>
同意教育部函請財政部資訊中心查調家庭年所得，若申請後有不符資格者，<br>
願無條件將已獲學校補助之助學金款項繳回，絕無異議。特此聲明。
            </td>
          </tr>

          <tr>
            <td colspan="5" style="text-align:center">
              <button
                class="btn active bg-info text-white rounded"
                @click="addNewCase()"
              >
                送出資料
              </button>
              &nbsp;
              <b-button
                style="width: 6.5rem"
                type="reset"
                @click="onReset"
                variant="danger"
                >Reset</b-button
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div v-else>
    <div class="course_title">請先新增銀行個人資料</div>

    <div class="table-responsive-sm">
      <table class="table" style="width: auto; text-align: left">
        <tbody></tbody>
      </table>
    </div>
  </div>
</template>

<script>
import * as tools from '../tool'

// 新申請案件元件：供學生填寫關係人資料、上傳戶籍謄本並送出助學金申請
//
// ⚠️  【維護注意】
// 以下三個元件共用相同的申請表單結構（關係人3列 + 國籍 + 戶籍謄本 + 本人同意）：
//   1. AddNewCaseView.vue  ← 本檔，學生新申請，上傳 API: UploadV2
//   2. EditCase.vue        ← 學生編輯申請，上傳 API: UploadV3
//   3. EditCase2.vue       ← 承辦人編輯申請，上傳 API: UploadV3
// 若需修改表單欄位、驗證邏輯或文字，三個元件都必須一併更新。
// 對應後端 API（需同步確認）：
//   - EconomicDisadvantage/AddNewCase
//   - EconomicDisadvantage/EditCase
//   - Common/UploadV2、Common/UploadV3
export default {
  name: 'AddNewCase',
  props: ['id1'], // id1：由父元件傳入的上傳金鑰前綴，會在 fileChange 中附加隨機字串以避免重複
  // props: [
  //   'memberShow2',
  //   'inputData2'
  // ],
  data () {
    return {
      relatedStudent1: null,
      nationalityOptions: [
        { value: 'TW', text: '本國籍' },
        { value: 'FN', text: '外國籍' }
      ],
      idError1: '',
      idError2: '',
      idError3: '',
      options1: [
        { value: null, text: '請選擇' },
        { value: 1, text: '父親' },
        { value: 2, text: '母親' },
        { value: 3, text: '配偶' },
        { value: 5, text: '法定代理人' }
      ],
      relatedStudent2: null,
      options2: [
        { value: null, text: '請選擇' },
        { value: 1, text: '父親' },
        { value: 2, text: '母親' },
        { value: 3, text: '配偶' },
        { value: 5, text: '法定代理人' }
      ],
      relatedStudent3: null,
      options3: [
        { value: null, text: '請選擇' },
        { value: 1, text: '父親' },
        { value: 2, text: '母親' },
        { value: 3, text: '配偶' },
        { value: 5, text: '法定代理人' }
      ],
      relatedName1: null,
      relatedName2: null,
      relatedName3: null,
      relatedId1: null,
      relatedId2: null,
      relatedId3: null,
      memberShow: this.$store.state.user2, // 控制表單顯示：false 時顯示「請先新增銀行資料」提示
      inputData: this.$store.state.inputData, // 登入後的學生基本資料（含 usrData.id、schyy、smt）
      inputData2: null,
      mode: false,
      file: null, // 使用者選取的本機 File 物件；上傳成功後 queryInfo.Info1 才會有值
      total: 0,
      isIE: false,
      selectedRowIndex: 0,
      currentPage: 1,
      pageSize: 10,
      queryInfo: {
        id: '',
        stdID: '',
        Info1: [],
        file: [{ name: '', RowId: '' }],
        sid: '',
        relatedName1: null,
        relatedName2: null,
        relatedName3: null,
        relatedId1: null,
        relatedId2: null,
        relatedId3: null,
        relatedStudent1: null,
        relatedStudent2: null,
        relatedStudent3: null,
        relatedNationality1: 'TW',
        relatedNationality2: 'TW',
        relatedNationality3: 'TW',
        schyy: null,
        smt: null,
        UpdateUser: null
      }
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    filteredDocs: function () {
      let data = []
      if (this.inputData != null) {
        data = this.inputData.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        )
      }
      return data
    },
    headerColor () {
      return '#f7e8aa'
    }
  },
  methods: {
    // 重設表單所有欄位至初始狀態（關係人資料、國籍、錯誤訊息、上傳檔案）
    onReset () {
      const vm = this
      vm.queryInfo.relatedStudent1 = null
      vm.queryInfo.relatedStudent2 = null
      vm.queryInfo.relatedStudent3 = null
      vm.queryInfo.relatedName1 = null
      vm.queryInfo.relatedName2 = null
      vm.queryInfo.relatedName3 = null
      vm.queryInfo.relatedId1 = null
      vm.queryInfo.relatedId2 = null
      vm.queryInfo.relatedId3 = null
      vm.queryInfo.relatedNationality1 = 'TW'
      vm.queryInfo.relatedNationality2 = 'TW'
      vm.queryInfo.relatedNationality3 = 'TW'
      vm.idError1 = ''
      vm.idError2 = ''
      vm.idError3 = ''
      vm.file = null
    },
    // 通知父元件切換至指定案件頁（送出成功後以 id=1 返回列表）
    CaseSelect (id) {
      this.$emit('CaseSelect', id)
    },

    // 通用空值判斷：空字串、null、undefined 均視為空
    isEmpty (data) {
      return !(data !== '' && data !== null && data !== undefined)
    },
    FileisEmpty (data) {
      // 空的、不是 File/Blob、或是 size 為 0 → 空
      if (!data || !(data instanceof Blob || data instanceof File) || data.size === 0) {
        return true
      }
      return false
    },

    checkVal (str) {
      var regExp = /^[A-Z]\d{9}$/
      if (regExp.test(str)) return true
      else return false
    },
    // 關係人身分證 / 居留證輸入時：轉大寫並清除錯誤訊息，n 為關係人編號（1~3）
    onIdInput (n) {
      const val = this.queryInfo['relatedId' + n]
      if (val) {
        this.queryInfo['relatedId' + n] = val.toUpperCase()
      }
      this['idError' + n] = ''
    },
    // 關係人身分證 / 居留證欄位失焦時即時驗證格式，n 為關係人編號（1~3）
    validateIdOnBlur (n) {
      const id = this.queryInfo['relatedId' + n]
      const nat = this.queryInfo['relatedNationality' + n]
      const rel = this.queryInfo['relatedStudent' + n]
      if (!id) {
        this['idError' + n] = ''
        return
      }
      const ok = nat === 'TW' ? tools.checkTWID(id) : tools.checkARC(id)
      if (!ok) {
        this['idError' + n] = '格式不正確'
        return
      }
      this['idError' + n] = tools.checkGenderMatch(id, nat, rel) ? '' : '性別與關係不符（父親應為男性、母親應為女性）'
    },
    /**
     * 送出前欄位驗證。
     * 關係人1：若三欄（姓名、關係、證號）不全空，則三欄均必填且格式正確。
     * 關係人2、3：以姓名是否填寫為觸發條件，有填姓名則其餘欄位必填。
     * 最後確認戶籍謄本已選取且已成功上傳至伺服器（queryInfo.Info1 有值）。
     * 回傳 msg：空字串表示驗證通過，非空字串為錯誤訊息。
     */
    checkSaveData () {
      var msg = ''

      // 檢查是否「關係人1」的三個欄位全為空
      const isRelated1AllEmpty =
    this.isEmpty(this.queryInfo.relatedId1) &&
    this.isEmpty(this.queryInfo.relatedName1) &&
    this.isEmpty(this.queryInfo.relatedStudent1)

      // 如果不是全空，就進行驗證
      if (!isRelated1AllEmpty) {
        if (this.isEmpty(this.queryInfo.relatedId1)) {
          msg = '請輸入關係人身分證1'
          return msg
        }

        const ret1 = this.queryInfo.relatedNationality1 === 'TW'
          ? tools.checkTWID(this.queryInfo.relatedId1)
          : tools.checkARC(this.queryInfo.relatedId1)
        if (!ret1) {
          msg = '關係人1身分證/居留證格式不正確'
          return msg
        }

        if (!tools.checkGenderMatch(this.queryInfo.relatedId1, this.queryInfo.relatedNationality1, this.queryInfo.relatedStudent1)) {
          msg = '關係人1性別與關係不符（父親應為男性、母親應為女性）'
          return msg
        }

        if (this.isEmpty(this.queryInfo.relatedName1)) {
          msg = '請輸入關係人姓名1'
          return msg
        }

        if (this.isEmpty(this.queryInfo.relatedStudent1)) {
          msg = '請選擇與學生關係1'
          return msg
        }
      }

      // 關係人2的檢查（與原本相同）
      if (!this.isEmpty(this.queryInfo.relatedName2)) {
        if (this.isEmpty(this.queryInfo.relatedId2)) {
          msg = '請輸入關係人身分證2'
          return msg
        }

        const ret2 = this.queryInfo.relatedNationality2 === 'TW'
          ? tools.checkTWID(this.queryInfo.relatedId2)
          : tools.checkARC(this.queryInfo.relatedId2)
        if (!ret2) {
          msg = '關係人2身分證/居留證格式不正確'
          return msg
        }

        if (!tools.checkGenderMatch(this.queryInfo.relatedId2, this.queryInfo.relatedNationality2, this.queryInfo.relatedStudent2)) {
          msg = '關係人2性別與關係不符（父親應為男性、母親應為女性）'
          return msg
        }

        if (this.isEmpty(this.queryInfo.relatedName2)) {
          msg = '請輸入關係人姓名2'
          return msg
        }

        if (this.isEmpty(this.queryInfo.relatedStudent2)) {
          msg = '請選擇與學生關係2'
          return msg
        }
      }

      // 關係人3的檢查（與原本相同）
      if (!this.isEmpty(this.queryInfo.relatedName3)) {
        if (this.isEmpty(this.queryInfo.relatedId3)) {
          msg = '請輸入關係人身分證3'
          return msg
        }

        const ret3 = this.queryInfo.relatedNationality3 === 'TW'
          ? tools.checkTWID(this.queryInfo.relatedId3)
          : tools.checkARC(this.queryInfo.relatedId3)
        if (!ret3) {
          msg = '關係人3身分證/居留證格式不正確'
          return msg
        }

        if (!tools.checkGenderMatch(this.queryInfo.relatedId3, this.queryInfo.relatedNationality3, this.queryInfo.relatedStudent3)) {
          msg = '關係人3性別與關係不符（父親應為男性、母親應為女性）'
          return msg
        }

        if (this.isEmpty(this.queryInfo.relatedName3)) {
          msg = '請輸入關係人姓名3'
          return msg
        }

        if (this.isEmpty(this.queryInfo.relatedStudent3)) {
          msg = '請選擇與學生關係3'
          return msg
        }
      }

      // 上傳檔案檢查
      if (this.FileisEmpty(this.file)) {
        msg = '請上傳戶籍謄本'
        return msg
      }
      // 確認檔案已成功上傳至伺服器
      if (!this.queryInfo.Info1 || this.queryInfo.Info1.length === 0) {
        msg = '戶籍謄本上傳尚未完成，請稍候再試'
        return msg
      }

      return msg
    },

    // 產生 16 字元的隨機英數字串，附加於 id1 之後以確保每次上傳的檔案鍵值唯一
    generateRandomString () {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      let randomString = ''

      for (let i = 0; i < 16; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length)
        randomString += characters.charAt(randomIndex)
      }

      return randomString
    },

    // fileChange(index) {
    //   //  var vm = this;
    //   this.formData = new FormData();

    //   if (index == 0) {
    //     this.id1=this.id1 + this.generateRandomString() ;

    //        this.formData.append(this.id1, this.file);
    //   }

    //   this.$http
    //     .post("./WebApi/Common/UploadV2", this.formData)
    //     .then((response) => {
    //       if (!tools.isNull(response.data)) {
    //         if (index == 0) this.queryInfo.Info1 = response.data;
    //       } else {
    //         tools.showAlert(vm, "danger", "上傳檔案失敗，請重新上傳" + error);
    //       }
    //     })
    //     .catch(function (error) {
    //       tools.showAlert(vm, "danger", "網路連線失敗，請重新上傳" + error);
    //     });
    // },

    /**
     * 使用者選取檔案後觸發（index=0 對應戶籍謄本）。
     * 流程：副檔名驗證 → 組 FormData → POST 上傳 → 成功後寫入 queryInfo.Info1。
     * 上傳失敗（含網路錯誤）時重設 file 及 file input，確保 checkSaveData 能正確攔截。
     */
    fileChange (index) {
      // 清除舊的 FormData
      this.formData = new FormData()

      const allowedExtensions = ['jpg', 'jpeg', 'png', 'gif', 'pdf']

      // 檢查是否有檔案
      if (!this.file) return

      const fileName = this.file.name || ''
      const extension = fileName.split('.').pop().toLowerCase()

      // 副檔名驗證
      if (!allowedExtensions.includes(extension)) {
        alert('檔案格式錯誤，僅限上傳 JPG, PNG, GIF, PDF 檔案')
        this.file = null
        this.$refs['file-input'].reset()
        return
      }

      if (index === 0) {
        this.id1 = this.id1 + this.generateRandomString()
        this.formData.append(this.id1, this.file)
      }

      this.$http
        .post('./WebApi/Common/UploadV2', this.formData)
        .then((response) => {
          if (!tools.isNull(response.data)) {
            if (index === 0) this.queryInfo.Info1 = response.data
          } else {
            this.file = null
            this.$refs['file-input'].reset()
            tools.showAlert(this, 'danger', '上傳檔案失敗，請重新上傳')
          }
        })
        .catch((error) => {
          this.file = null
          this.$refs['file-input'].reset()
          tools.showAlert(this, 'danger', '網路連線失敗，請重新上傳：' + error)
        })
    },

    getToday () {
      var dd = new Date()
      var today = dd.getDate().toString().padStart(2, '0') // 內建getDate 取到目前年月日
      var mm = (dd.getMonth() + 1).toString().padStart(2, '0') // January is 0!
      var yyyy = dd.getFullYear()
      return tools.stringFormat('{0}/{1}/{2}', yyyy - 1911, mm, today)
    },
    // 送出申請：先執行欄位驗證，通過後 PUT 新增案件，成功後通知父元件返回列表
    addNewCase: function () {
      var msg = this.checkSaveData()
      if (msg.length !== 0) {
        alert(msg)
        return null
      }

      const vm = this
      // vm.queryInfo.sid = vm.inputData.usrData.id;

      // vm.queryInfo.schyy = vm.inputData.usrData.schyy;
      // vm.queryInfo.smt = vm.inputData.usrData.smt;

      vm.queryInfo.UpdateUser = vm.inputData.usrData.id

      // console.log(vm.queryInfo);
      // 新增
      this.$http
        .put('./WebApi/EconomicDisadvantage/AddNewCase/', vm.queryInfo)
        .then((response) => {
          if (response.data > 0) {
            alert('新增上傳成功')
            this.CaseSelect(1)
            //   this.$store.dispatch('actionLogin2', vm.memberShow);
            //  this.$store.dispatch('actionLogin2Data', vm.inputData);
            // vm.$router.push({ path:'StdLogin' }) ;
            // window.location.replace("/StdLogin");
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
        })
    },
    // 確認學生是否已建立銀行帳號資料；若尚未建立則隱藏申請表單並提示
    getReortsSid () {
      const vm = this

      vm.queryInfo.sid = vm.inputData.usrData.id
      this.$http
        .get(
          './WebApi/EconomicDisadvantage/GetReortsSid/'.concat(vm.queryInfo.sid)
        )
        .then((response) => {
          if (response.data === null || response.data === 0) {
            vm.memberShow = false
            alert('請先新增銀行個人資料')
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
        })
    },
    // 取得目前開放申請的學年度與學期，填入 queryInfo 以顯示於表單及送出資料
    GetCurrentSchyy () {
      const vm = this

      vm.queryInfo.sid = vm.inputData.usrData.id
      this.$http
        .get('./WebApi/EconomicDisadvantage/GetCurrentSchyy/')
        .then((response) => {
          if (response.data !== null && response.data !== 0) {
            vm.queryInfo.schyy = response.data.schyy
            vm.queryInfo.smt = response.data.smt
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, 'danger', '對不起,網路連線失敗' + error)
        })
    }
  },
  created () {
    console.log('======created AddNewCaseView =====')
    this.getReortsSid()
    this.GetCurrentSchyy()
  },
  mounted () {
    console.log('======mounted AddNewCaseView  =====')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 關係人表格欄位對齊：header 列與 data 列使用相同 rel-row class，透過 nth-child 固定每欄寬度 */
.rel-row > div:nth-child(1) { width: 3.5rem; text-align: center; justify-content: center; }
.rel-row > div:nth-child(3) { min-width: 9rem; }
.rel-row > div:nth-child(4) { min-width: 7rem; }
</style>
